import { reactive, ref } from "vue";

export const scrollTop = reactive(ref(0))

export function updateScrollTop(event: any) {
  scrollTop.value = event?.target?.scrollTop ?? 0;
}